import { Grid, MenuItem } from '@mui/material';
import TextField from '@mui/material/TextField';
import React from 'react';
import { useDispatch } from 'react-redux';

export interface IFormulaireProps {
    user: any;
    setUser: any;
}

const EditUser = (props: IFormulaireProps) => {
    const { user, setUser } = props
    console.log("🚀 ~ file: EditUser.tsx:13 ~ EditUser ~ user:", user)

    const handleInputChange = (e: any) => {
        const { name, value } = e.target
        setUser({ ...user, [name]: value })
    }

    return (
        <div>
            <Grid container spacing={2}>
                <Grid item md={12} xs={12} sm={12}>
                    <TextField
                        label={'login'}
                        fullWidth
                        required
                        margin="dense"
                        size="small"
                        type="text"
                        variant="standard"
                        name="nomUtilisateur"
                        value={user.nomUtilisateur}
                        onChange={handleInputChange}
                    />
                </Grid>
                <Grid item md={12} xs={12} sm={12}>
                    <TextField
                        label={"Mot de passe"}
                        fullWidth
                        required
                        margin="dense"
                        size="small"
                        type="text"
                        variant="standard"
                        name="motDePasseInitial"
                        value={user.motDePasseInitial}
                        onChange={handleInputChange}
                    />
                </Grid>
            </Grid>
        </div>
    );
}

export default EditUser;
